<template>
    <div>
        <div :id="tableID" class="playersTable">
            <span class="sectionTitle">{{sectionTitle}}</span>
            <div class="head">
                <span class="rankTitle">{{ $t("players.rank") }}</span>
                <span class="playerTitle">{{ $t("players.player") }}</span>
                <span class="teamNameTitle">{{ $t("players.teamName") }}</span>
                <span class="totalTitle">{{ $t("players.total") }}</span>
            </div>
            <div v-for="(player, index) in playerList" :key="index">
                <div class="playersCell" v-if="index < 10 || showAll">
                    <span class="rank">{{player.rank}}</span>
                    <playerAvatar @click.native="clickPlayerName(player.playerId)" class="playerAvatar" id='playerAvatar' :playerId='String(player.playerId)'/>
                    <span class="player" @click="clickPlayerName(player.playerId)">
                      {{player.player}}
                    </span>
                    <span class="teamName" @click="clickTeamName(player.teamId)">{{player.team}}</span>
                    <span class="total">{{player.num}}</span>
                </div>
                <hr/>
            </div>
            <!-- <span class="showAll" @click="showAll = !showAll">{{ $t("players.showAll") }}</span> -->
            <!-- <img class="showAllImg" alt="" src="~@/assets/football/players/btn_showAll.png"> -->
        </div>
    </div>
</template>

<script>
import playerAvatar from '@/components/PlayerAvatar'

export default {
  props: {
    playerList: {
      type: Array, // [title]
      require: true,
      default: function () {
        return []
      }
    },
    sectionTitle: {
      type: String,
      required: true
    },
    tableID: {
      type: String,
      required: true
    }
  },
  components: {
    playerAvatar
  },
  data () {
    return {
      showAll: true
    }
  },
  methods: {
    clickPlayerName: function (playerId) {
      this.$router.push({ name: 'football-player-info', params: { playerId: playerId.toString() } })
    },
    clickTeamName: function (teamId) {
      this.$router.push({ name: 'football-team-schedule', params: { teamId: teamId.toString() } })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style"
</style>
